var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"relative"},[_c('div',{staticClass:"progress-bar",style:({ width: (_vm.progress + "%") })}),_c('ul',{staticClass:"progress-dots"},_vm._l((_vm.totalStepsRange),function(v){return _c('li',{key:v,class:{
        dot: v !== 1,
        passed: v - 1 <= _vm.currentStep,
        active: v - 1 === _vm.currentStep,
      }})}),0),_c('ul',{staticClass:"steps"},_vm._l((_vm.totalStepsRange),function(v){return _c('li',{key:v,class:{ dot: v !== 1 }})}),0)])}
var staticRenderFns = []

export { render, staticRenderFns }